import type { ReactNode } from "react";

import { TabPageTitle } from "./TabPageTitle";

export {
  TAB_TITLE_BASE_FONT_PX,
  TAB_TITLE_CLASS,
  TAB_TITLE_FIT_CLASS,
} from "./TabPageTitle";
export const TAB_TIMEFRAME_CLASS = "text-sm font-semibold uppercase text-[oklch(64%_0.04_155)]";
/** Opt-in on TabPageShell — tighter fixed-title-to-first-body spacing (Habits/Insight reference). */
export const TAB_BODY_COMPACT_TIMEFRAME_CLASS = "screen0-tab-body-compact-timeframe";

type TabPageHeaderProps = {
  title?: string;
  titleSlot?: ReactNode;
  actions?: ReactNode;
};

export function TabPageHeader({ title, titleSlot, actions }: TabPageHeaderProps) {
  const titleNode = titleSlot ?? (title ? <TabPageTitle title={title} /> : null);

  if (actions) {
    return (
      <div className="grid grid-cols-[minmax(0,1fr)_auto] items-start gap-3">
        {titleNode}
        <div className="flex items-end gap-2 self-end">{actions}</div>
      </div>
    );
  }

  return titleNode;
}

export function TabPageTimeframe({ children }: { children: ReactNode }) {
  return <p className={TAB_TIMEFRAME_CLASS}>{children}</p>;
}
